import Tag from "../../../model/tag/Tag";

/**
 * Tags fetched action.
 */
export const TAGS_FETCHED = "TAGS_FETCHED";
export type TAGS_FETCHED = { tags: Tag[] }

/**
 * Job tags fetched action.
 */
export const JOB_TAGS_FETCHED = "JOB_TAGS_FETCHED";
export type JOB_TAGS_FETCHED = { tags: Tag[] }

export const TAGS_SET_TO_LEAD = "TAGS_SET_TO_LEAD";
export type TAGS_SET_TO_LEAD = { leadId: string, tags: Tag[] };

export const TAGS_SET_TO_JOB = "TAGS_SET_TO_JOB";
export type TAGS_SET_TO_JOB = { jobId: string, tags: Tag[] };